import i18next from "i18next";
import { FieldPath } from "react-hook-form";
import { UseFormGetFieldState, UseFormTrigger } from "react-hook-form/dist/types/form";
import { QuantityInfoApi } from "../../../../../../../../../services/Api/Organization/types";
import { getModifiersSumOfDefaultQuantity } from "./index";
import { ValidateModifierConfig, ValidateModifierMinPermitted } from "./types";

export const validateModifierMinPermitted = ({
	minPermitted,
	maxPermitted,
	modifierGroupMaxPermitted,
}: ValidateModifierMinPermitted) => {
	if (typeof minPermitted !== "number") return true;
	const maxPermittedValidation = typeof maxPermitted === "number" ? maxPermitted >= minPermitted : true;
	const modifierGroupMaxPermittedValidation =
		typeof modifierGroupMaxPermitted === "number" ? modifierGroupMaxPermitted >= minPermitted : true;

	return maxPermittedValidation && modifierGroupMaxPermittedValidation;
};

export const validateModifierMaxPermitted = ({
	maxPermitted,
	minPermitted,
	defaultQuantity,
}: ValidateModifierConfig) => {
	if (typeof maxPermitted !== "number") return true;
	const defaultQuantityValidation = typeof defaultQuantity === "number" ? defaultQuantity <= maxPermitted : true;
	const minPermittedValidation = typeof minPermitted === "number" ? maxPermitted >= minPermitted : true;

	return defaultQuantityValidation && minPermittedValidation;
};

export const validateModifierDefaultQuantity = ({
	maxPermitted,
	minPermitted,
	defaultQuantity,
}: ValidateModifierConfig) => {
	if (typeof defaultQuantity !== "number") return true;
	const minPermittedValidation = typeof minPermitted === "number" ? defaultQuantity >= minPermitted : true;
	const maxPermittedValidation = typeof maxPermitted === "number" ? defaultQuantity <= maxPermitted : true;

	return maxPermittedValidation && minPermittedValidation;
};

export const modifierGroupMinPermittedValidate = (
	minPermitted?: number | string | null,
	maxPermitted?: number | string | null
) => {
	if (typeof minPermitted !== "number") return true;

	if (typeof maxPermitted === "number" && minPermitted > maxPermitted) {
		return i18next.t("constraints.constraints.quantity_info");
	}

	return true;
};

export const modifierGroupMaxPermittedValidate = (
	watchedOptions: QuantityInfoApi[],
	minPermitted?: number | string | null,
	maxPermittedInput?: number | string | null
) => {
	if (typeof maxPermittedInput !== "number") return true;
	const defaultQuantitiesSum = getModifiersSumOfDefaultQuantity(watchedOptions);

	if (defaultQuantitiesSum && defaultQuantitiesSum > maxPermittedInput) {
		return i18next.t("constraints.default_quantity_greater_than_max_permitted");
	}

	if (typeof minPermitted === "number" && minPermitted > maxPermittedInput) {
		return i18next.t("constraints.constraints.quantity_info");
	}

	return true;
};

export const runModifierForeignFieldValidationOnInputChange = async <FormType extends Record<string, any>>(
	foreignFields: FieldPath<FormType> | FieldPath<FormType>[],
	trigger: UseFormTrigger<FormType>,
	getFieldState: UseFormGetFieldState<FormType>
) => {
	const foreignFieldsArray = Array.isArray(foreignFields) ? foreignFields : [foreignFields];

	for (const foreignField of foreignFieldsArray) {
		const { error } = getFieldState(foreignField);

		if (error) {
			await trigger(foreignField);
		}
	}
};
